// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"147":"20b6c057","471":"1a33afe0","674":"924ab4cd","713":"cef662d0","852":"1a33afe0"}[chunkId] + ".chunk.css";
};